<script setup lang="ts">
/**
 * The request-page prompt for a seller whose own owner details are still open.
 *
 * Presentational: no props, one event. The host decides whether it shows at all.
 */
import Box from '@uiKit/elements/Box.vue'
import Button from '@uiKit/elements/Button.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'
import Text from '@uiKit/elements/Text.vue'
import Card from '@uiKit/components/Card.vue'

defineEmits<{ (e: 'start'): void }>()
</script>

<template>
  <Card variant="outlined" padding="4">
    <Box flex align="center" justify="between" gap="4" class="owner-banner">
      <Box flex align="start" gap="3">
        <PiIcon name="id-card" class="owner-banner__icon" />
        <Box direction="col" gap="1">
          <Text type="heading">Complete your owner details</Text>
          <Text type="body-sm" color="muted">
            You're one of this property's owners. Finish your verification and payout details here.
          </Text>
        </Box>
      </Box>
      <Button label="Continue" icon="arrow-right" icon-pos="right" @click="$emit('start')" />
    </Box>
  </Card>
</template>

<style scoped>
.owner-banner__icon {
  color: var(--p-primary-600);
  padding-top: 0.125rem;
}

@media (max-width: 992px) {
  .owner-banner {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
